"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _nuiIntlRuntime = require("@concur/nui-intl-runtime");
var _Button = _interopRequireDefault(require("@concur/nui-widgets/lib/Buttons/Button"));
var _Icon = _interopRequireDefault(require("@concur/nui-widgets/lib/Icon/Icon"));
var _Modal = _interopRequireDefault(require("@concur/nui-widgets/lib/Modal/Modal"));
var _listingModule = require("./listingModule");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var ConfirmationModal = function ConfirmationModal(_ref) {
  var isConfirmationModalOpen = _ref.isConfirmationModalOpen,
    modalNames = _ref.modalNames,
    toggle = _ref.toggle,
    options = _ref.options,
    formatter = _ref.formatter;
  var toggleThisModal = function toggleThisModal() {
    return toggle(modalNames.confirmation);
  };
  var getModalHeader = function getModalHeader() {
    if (options.listingType === 'ACONCT') {
      return options.disconnectSuccess ? /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
        id: "UnenrollSuccessful"
      }) : /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
        id: "UnenrollFail"
      });
    }
    return options.disconnectSuccess ? /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "DisconnectSuccessful"
    }) : /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "DisconnectFail"
    });
  };
  var getModalBody = function getModalBody() {
    return options.disconnectSuccess ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "col-xs-1"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      iconName: "messaging-success",
      size: "lg"
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "col-xs-11"
    }, options.listingType === 'ACONCT' ? /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "UnenrollSuccessfulMessage"
    }) : /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "DisconnectSuccessfulMessage"
    }))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "col-xs-1"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      iconName: "messaging-error",
      size: "lg"
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "col-xs-11"
    }, options.listingType === 'ACONCT' ? /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "UnenrollFailMessage"
    }) : /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "DisconnectFailMessage"
    })));
  };
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    show: isConfirmationModalOpen,
    onHide: toggleThisModal,
    "aria-label": formatter.formattedMessage({
      id: 'ConfirmationModalLabel'
    }),
    size: "md",
    modalContainerClassName: "modal-container"
  }, /*#__PURE__*/_react.default.createElement(_Modal.default.Header, {
    closeLabel: formatter.formattedMessage({
      id: 'Close'
    }),
    closeButton: "true",
    onHide: toggleThisModal
  }, /*#__PURE__*/_react.default.createElement(_Modal.default.Title, {
    headingLevel: "3"
  }, getModalHeader())), /*#__PURE__*/_react.default.createElement(_Modal.default.Body, {
    className: "centered-modal-body"
  }, getModalBody()), /*#__PURE__*/_react.default.createElement(_Modal.default.Footer, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-xs-12"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: "pull-right",
    onClick: toggleThisModal
  }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "Ok"
  })))));
};
var mapStateToConfirmationProps = function mapStateToConfirmationProps(state) {
  return {
    isConfirmationModalOpen: state.listing.isConfirmationModalOpen,
    listingData: state.listing,
    modalNames: state.listing.modalNames,
    options: state.listing.modalOptions
  };
};
ConfirmationModal.propTypes = {
  formatter: _propTypes.default.object,
  isConfirmationModalOpen: _propTypes.default.bool.isRequired,
  modalNames: _propTypes.default.object.isRequired,
  options: _propTypes.default.object.isRequired,
  toggle: _propTypes.default.func.isRequired
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToConfirmationProps, {
  toggle: _listingModule.toggleModal
})((0, _nuiIntlRuntime.withFormatter)(ConfirmationModal));